import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function capitalizeFirstLetter(str: string) {
  if(!str?.length) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const getStatusLabel = (status: string) => {
  switch (status) {
    case "published":
      return "Publiée";
    case "unPublished":
      return "Non publiée";
    case "approved":
      return "Approuvé";
    case "pending":
      return "En attente";
    case "rejected":
      return "Rejeté";
    default:
      return status;
  }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "approved":
      return "bg-emerald-100 text-green-800";
    case "published":
      return "bg-emerald-100 text-green-800";
    case "pending":
      return "bg-amber-100 text-amber-800";
    case "unPublished":
      return "bg-amber-100 text-amber-800";
    case "rejected":
      return "bg-red-100 text-red-800";
    default:
      return "default";
  }
};

export const formatPrice = (price: number) => {
  return `${price} €`;
};

export const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) {
    return "";
  }
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return dateString;
  }
  return date.toLocaleDateString("fr-FR");
};
export const formatCurrency = (
  amount: number | string,
  options?: Intl.NumberFormatOptions
) => {
  if (typeof amount === "string") return amount;

  const opts: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  };

  return new Intl.NumberFormat("fr-FR", {
    ...opts,
  }).format(amount);
};

export const handleExternalSubmit = (
  e: React.FormEvent,
  formRef: React.RefObject<HTMLFormElement> | null
) => {
  e.preventDefault();
  if (!formRef) return;
  formRef.current?.dispatchEvent(
    new Event("submit", { cancelable: true, bubbles: true })
  );
};
